import { pluralRu } from "@mylaunch/utils"

function formatDate(date: Date): string {
  const today = new Date()
  const tomorrow = new Date(today)
  tomorrow.setDate(today.getDate() + 1)

  const shortDate = date.toLocaleDateString("ru-RU", { day: "numeric", month: "long" }).replace(".", "")
  if (date.toDateString() === today.toDateString()) return `Сегодня, ${shortDate}`
  if (date.toDateString() === tomorrow.toDateString()) return `Завтра, ${shortDate}`
  return date.toLocaleDateString("ru-RU", { day: "numeric", month: "long" })
}

export function EventListHeader({ date, count }: { date: Date; count: number }) {
  return (
    <div className="flex items-center justify-between py-m">
      <div className="text-lg font-semibold">{formatDate(date)}</div>
      {count > 0 && <span className="bg-primary text-primary-foreground text-sm rounded-lg px-s py-xs">{count} {pluralRu(count, "событие", "события", "событий")}</span>}
    </div>
  )
}
